var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGatewayConnection = function SvgGatewayConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M1.41 8.09a1.394 1.394 0 1 0 2.789 0 1.394 1.394 0 0 0-2.789 0Zm-.536 0a1.93 1.93 0 1 0 3.861 0 1.93 1.93 0 0 0-3.861 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M8.148 6.493c-.72.927-1.843 1.33-3.52 1.33v.535c1.757 0 3.078-.423 3.944-1.536.85-1.093 1.213-2.797 1.213-5.237H9.25c0 2.414-.365 3.962-1.1 4.908Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M7.621 1.956 9.327.249a.268.268 0 0 1 .38 0l1.706 1.707a.268.268 0 0 1-.38.379L9.786 1.086v.5H9.25v-.5L8 2.335a.268.268 0 1 1-.379-.38Z",
    clipRule: "evenodd"
  })));
};
export default SvgGatewayConnection;